import type { SVGProps } from 'react'

const SvgSortArrowUser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_46219_13324)">
      <path
        d="M6.705 2.70404L6 1.99904L8 -0.000955669L10 1.99904L9.295 2.70404L8.5 1.91404V6.74219L7.5 6.74219L7.5 1.91404L6.705 2.70404Z"
        fill="#5E5E5E"
      />
      <path
        d="M4.43563 8.00959L5.14063 8.71459L3.14063 10.7146L1.14063 8.71459L1.84563 8.00959L2.64063 8.79959L2.64063 0.857422L3.64063 0.857422L3.64063 8.79959L4.43563 8.00959Z"
        fill="#0A6FCD"
      />
    </g>
    <defs>
      <clipPath id="clip0_46219_13324">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="matrix(0 -1 -1 -4.37114e-08 12 12)"
        />
      </clipPath>
    </defs>
  </svg>
)
export default SvgSortArrowUser
